/* global axios */
import ApiClient from './ApiClient';

class AdvisorReportsAPI extends ApiClient {
  constructor() {
    super('advisor_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  summary(params) {
    return axios.get(`${this.url}/summary`, { params });
  }

  advisors(params) {
    return axios.get(`${this.url}/advisors`, { params });
  }

  conversations(params) {
    return axios.get(`${this.url}/conversations`, { params });
  }

  export(params) {
    return axios.get(`${this.url}/export`, { params, responseType: 'blob' });
  }
}

export default new AdvisorReportsAPI();
